/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { TableCell, TableRow, Button, TextField, Box } from '@mui/material';
import { Image, Space } from "antd";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { productGSTHead } from "../../../../../config/constant";
import customStyles from "../../../../../assets/styles/customStyles";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import { NavLink } from "react-router-dom";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import clsx from "clsx";
import { toast } from 'react-toastify';
import usePrevious from "../../../../Shared/components/Previous";
import { useDispatch, useSelector } from "react-redux";
import crudActions from "../../../../CRUD/redux/actions";
import { emptyValidation } from "../../../../../helpers/validation";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { checkCRUDPermission, getColumnWidth } from "../../../../../helpers/utilities";

export const ProductGstCodeTable = (props) => {

    const { onRequestSort, sortOrder, sortBy, details, loadTasks, loadMore, loadMoreContent, loadMoreTask, roleManagement } = props;
    const [visible, setVisible] = useState(false);
    const { editDetails, editError, editLoader } = useSelector(state => state.crudReducer);
    const [gstId, setGstId] = useState('');
    const [gstCode, setGstCode] = useState('');
    const [description, setDescription] = useState('');
    const [percentage, setPercentage] = useState('');
    const [errorGst, setErrorGst] = useState(false);
    const [errorPercentage, setErrorPercentage] = useState(false);
    const prevEditDetails = usePrevious(editDetails);
    const [deleteModal, setDeleteModal] = useState(false);
    const prevEditError = usePrevious(editError);

    const dispatch = useDispatch();

    const onEdit = (data) => {
        setVisible(true);
        setGstId(data.id);
        setGstCode(data.code);
        setDescription(data.description);
        setPercentage(data.percentage);
    }

    const emptyState = () => {
        setErrorGst(false);
        setErrorPercentage(false);
    };
    const editGst = (e) => {
        e.preventDefault();
        // let emptyGst = customAlaphaNumericOnlyValidation('Gst Code', gstCode);
        let emptyGst = emptyValidation('Gst Code', gstCode);
        let emptyPercentage = emptyValidation('Percentage', percentage);
        emptyState();
        if (emptyGst.isValid && emptyPercentage.isValid) {
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                url: 'productgst',
                id: gstId,
                title: 'Product Gst',
                details: {
                    code: gstCode,
                    description: description,
                    percentage: parseInt(percentage)
                }
            });
        } else {
            if (emptyGst.errors) {
                setErrorGst(emptyGst.errors);
            }
            if (emptyPercentage.errors) {
                setErrorPercentage(emptyPercentage.errors);
            }
        }
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            loadTasks();
            toast.dismiss();
            toast(editDetails);
            setVisible(false);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let error = editError.error.message.split("|");
            if (error[0] === 'code') {
                setErrorGst(error[1]);
            }
            if (error[0] === 'percentage') {
                setErrorPercentage(error[1]);
            }
        }
    }, [editDetails, editError, prevEditDetails, prevEditError]);

    const handleClose = () => {
        setVisible(false);
        emptyState();
    };

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setGstId(data.id);
        setGstCode(data.code);
    };


    const classes = customStyles()

    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={productGSTHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={6}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details?.length > 0 ? details?.map((data, i) => (
                                            <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell style={{ width: getColumnWidth(productGSTHead, 0) }}><span style={{ width: getColumnWidth(productGSTHead, 0) }}>{data.code}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(productGSTHead, 1) }}><span style={{ width: getColumnWidth(productGSTHead, 1) }} className={classes.descEllipsis}>{data.description ? data.description : '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(productGSTHead, 2) }}><span style={{ width: getColumnWidth(productGSTHead, 2) }}>{`${data.percentage}%`}</span></TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Product GST Code', 'edit', 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                                <Image
                                                                    src={EditIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Product GST Code', 'deletable', 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => onDelete(data)} >
                                                                <Image
                                                                    src={DeleteIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={6}>
                                                    <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start Creating Product GST'}</p>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }

                    </>
                }
            />
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={'Edit Product GST Code'}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => editGst(e)}
                    >
                        <div className={classes.customFormFlex}>
                            <TextField autoComplete='one-time-code'
                                label={["Product GST Code ", <span key={"Product GST Code"} className={classes.colorRedRequired}> *</span>]}
                                value={gstCode}
                                variant={'standard'}
                                disabled
                                error={errorGst ? true : false}
                                helperText={errorGst}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => setGstCode(e.target.value)}
                            />
                            <TextField autoComplete='one-time-code'
                                label='Description'
                                variant={'standard'}
                                value={description}
                                className={clsx(classes.margin30t)}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => setDescription(e.target.value)}
                            />
                            <TextField autoComplete='one-time-code'
                                label={["Percentage ", <span key={"Percentage"} className={classes.colorRedRequired}> *</span>]}
                                variant={'standard'}
                                error={errorPercentage ? true : false}
                                helperText={errorPercentage}
                                value={percentage}
                                className={clsx(classes.margin30t)}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => setPercentage(e.target.value)}
                            />
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Button
                                key="save"
                                type='submit'
                                color='primary'
                                variant="contained"
                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}
                            //onClick={() => editTeam()}
                            >
                                Update & Close
                            </Button>
                        </div>
                    </Box>
                }
            />
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={gstId} loadTasks={() => loadTasks()} name={gstCode} url={'productgst'} title={'Product GST'} visible={deleteModal} />
        </>
    )
}